import { render, staticRenderFns } from "./MultilineText.vue?vue&type=template&id=b0ed7352&scoped=true"
import script from "./MultilineText.vue?vue&type=script&lang=ts"
export * from "./MultilineText.vue?vue&type=script&lang=ts"
import style0 from "./MultilineText.vue?vue&type=style&index=0&id=b0ed7352&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ed7352",
  null
  
)

export default component.exports